export interface IRelatedArticle {
    name: string
    synopsis: string
    url: string
    images: IImage[]
    authors: string[]
    sponsor: string
}

interface IImage {
    image: {
        url: string
    }
}

interface IProps {
    article: IRelatedArticle
    single?: boolean
}

const RelatedArticle = ({article, single}: IProps) => {
    let image
    if (article?.images?.length > 0) {
        image = <img className="" src={article.images[0].image.url} />
    }

    let author
    if (article?.authors?.length > 0) {
        author = <div className="uppercase font-normal text-[11px] leading-[14px] tracking-[0.6px] pt-[15px]">By {article.authors[0]}</div>
    }

    let sponsor
    if (article?.sponsor !== undefined && article.sponsor.length > 0) {
        sponsor = (
            <div className="uppercase font-normal text-[11px] leading-[14px] tracking-[0.6px] pt-[15px]">
                Sponsored By <div className="font-semibold">{article.sponsor}</div>
            </div>
        )
    }

    const name = <div className="font-normal text-[16px] leading-[24px] tracking-[-0.2px]">{article?.name}</div>

    if (single) {
        return (
            <div className="p-[10px] bg-white">
                <a href={article?.url} target="site">
                    <div className="grid grid-cols-[177px_auto]">
                        {image}
                        <div className="p-[10px]">
                            {name}
                            {author}
                            {sponsor}
                        </div>
                    </div>
                </a>
            </div>
        )
    }

    return (
        <div className="w-[177px] m-[10px] ml-[5px] mr-[5px] bg-white">
            <a href={article?.url} target="site">
                <div className="">
                    {image}
                    <div className="p-[10px]">
                        {name}
                        {author}
                        {sponsor}
                    </div>
                </div>
            </a>
        </div>
    )
}

export default RelatedArticle
